var map = {
	"./0/主图.png": "8t2B",
	"./1/主图.png": "Vglf",
	"./2/主图.png": "jfBg",
	"./3/主图.png": "NdTC",
	"./4/主图.png": "8c7D",
	"./5/主图.png": "pAWK",
	"./6/主图.png": "pcCc",
	"./7/主图.png": "C77D",
	"./8/主图.png": "F+Vr",
	"./结果页/爱他人/谭义明/主图.png": "Tmrf",
	"./结果页/爱他人/赵婉婷/主图.png": "MxbO",
	"./结果页/爱他人/郑锐/主图.png": "03Ez",
	"./结果页/爱生活/徐健/主图.png": "PCSt",
	"./结果页/爱生活/曹晟康/主图.png": "mRaV",
	"./结果页/爱生活/沈丞晴/主图.png": "H4ux",
	"./结果页/爱自己/周富贵/主图.png": "xMc5",
	"./结果页/爱自己/田野/主图.png": "DspQ",
	"./结果页/爱自己/谢昌华/主图.png": "oKHM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xS05";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure ^\.\/.*\/主图\.png$
// module id = xS05
// module chunks = 1